import { useState } from 'react'
import { Outlet } from 'react-router-dom'

import { MobileSidebarTrigger, Sidebar } from './sidebar'

import type { ReactElement } from 'react'


export function AppShell(): ReactElement {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar />

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex h-14 items-center gap-3 border-b border-sidebar-border bg-sidebar px-4 text-sidebar-foreground md:hidden">
          <MobileSidebarTrigger open={mobileOpen} onOpen={setMobileOpen} />
          <span className="text-sm font-bold">TGTalentOS</span>
          <div className="flex-1" />
        </header>

        <main className="flex-1 px-4 py-5 sm:px-6 sm:py-6 lg:px-8">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
